import replace from 'lodash-es/replace';
import { getItemConfigElement } from './utils.js';

export const parseKey = key => replace(key || '', /\./g, '_');

// default header when we have an answer
const headerAnswered = (points, correctness) => ({
  data: null,
  autoScore: { points },
  correctnessGroup: correctness,
  sessionValueSubGroup: 'default',
});

// default header when we don't have an answer
const headerNotAnswered = () => ({
  data: null,
  autoScore: null,
  correctnessGroup: 'unanswered',
  sessionValueSubGroup: 'default',
});

// default headers in order to create all the necessary groups
export const defaultHeaders = () => ({
  headers: [
    headerAnswered(1, 'correct'),
    headerAnswered(0.5, 'correct-partially'),
    headerAnswered(0, 'incorrect'),
    headerNotAnswered(),
  ],
});

export const createSessionValueGroupingTag = (item, session) => {
  const { config } = item || {};
  const { data } = session || {};

  const { element: elementTag, models } = getItemConfigElement(config);
  const model = models && models[0];
  const { choices, choiceMode } = model || {};

  switch (elementTag) {
    case 'multiple-choice': {
      let sessionValueGropingTag;

      // for multiple-choice, if choiceMode is 'checkbox'
      // we don't group sessions
      if (choiceMode === 'checkbox') {
        return 'default';
      }

      try {
        // for multiple-choice, we group sessions by values; eg: 0_2_3 for A, C, D
        sessionValueGropingTag = data[0].value
          .map(val => choices.findIndex(choice => choice.value === val))
          .sort()
          .join('_');
      } catch (e) {
        sessionValueGropingTag = 'default';
      }

      return sessionValueGropingTag;
    }
    default:
      return 'default';
  }
};

export const createDefaultHeaders = item => {
  const { config } = item || {};
  const { element: elementTag, models } = getItemConfigElement(config);
  const model = models && models[0];
  const { choiceMode, choices, id, partialScoring, markup } = model || {};

  const headersWithoutPartial = {
    headers: [
      headerAnswered(1, 'correct'),
      headerAnswered(0, 'incorrect'),
      headerNotAnswered(),
    ],
  };
  const RESPONSE_AREA_REGEX = /{{(\w+)}}/g;

  // for multi-items, we return the default headers
  if (models.length > 1) {
    return defaultHeaders();
  }

  switch (elementTag) {
    case 'multiple-choice': {
      if (choiceMode === 'radio') {
        // for multiple-choice with choiceMode "radio", we have to create a column for each possible response:
        return {
          headers: choices.reduce(
            (acc, choice) => {
              const data = [{ id, value: [choice.value] }];

              acc.push({
                data,
                autoScore: {},
                correctnessGroup: choice.correct ? 'correct' : 'incorrect',
                sessionValueSubGroup: createSessionValueGroupingTag(item, {
                  data,
                }),
              });
              return acc;
            },
            // we default with the "unanswered" column
            [headerNotAnswered()]
          ),
        };
      }

      return defaultHeaders();
    }

    case 'explicit-constructed-response': {
      const hasOneResponseArea =
        (markup.match(RESPONSE_AREA_REGEX) || []).length === 1;

      if (partialScoring === false || hasOneResponseArea) {
        return headersWithoutPartial;
      }

      return defaultHeaders();
    }

    case 'math-inline': {
      return headersWithoutPartial;
    }

    default:
      return defaultHeaders();
  }
};
